import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { ToastContent } from "../../../shared/components";
import { LoadingComp } from "../../../shared/components/loading/Loading";
import { useDebounce, useToast } from "../../../shared/hooks";
import { LayoutBaseDePagina } from "../../../shared/layouts";
import { PeopleService } from "../../../shared/services/api/people/PeopleService";
import { TablePeople } from "./TablePeople";
import { PeopleToolbar } from "./ToolbarPeople";
import { ModalCreatePeople } from "../Modals/ModalCreatePeople";

export const PeopleListPresentation = () => {
	const [searchParams, setSearchParams] = useSearchParams();
	const { debounce } = useDebounce();
	const toastHandler = useToast();

	// Estados dos filtros
	const [textSearch, setTextSearch] = useState("");
	const [status, setStatus] = useState("Todos");
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(10);
	const [totalCount, setTotalCount] = useState(0);

	// Dados da listagem e controle de loading
	const [peopleData, setPeopleData] = useState<any[]>([]);
	const [isLoading, setIsLoading] = useState(false);
	const [refreshTable, setRefreshTable] = useState(false);
	const [modalCreateOpen, setModalCreateOpen] = useState(false);

	const handleRefreshTable = () => {
		setRefreshTable((prev) => !prev);
	};

	const handleCreate = () => {
		setModalCreateOpen(true);
	};

	const handleFetchData = (currentPage: number, limit: number, search: string, status: string) => {
		setIsLoading(true);
		debounce(() => {
			PeopleService.getAll(currentPage + 1, limit, search, status)
				.then((response) => {
					if (response instanceof Error) {
						toastHandler.present({
							type: "error",
							position: "top-right",
							messageOrContent: <ToastContent title="Erro" content="Erro ao buscar comissões" />,
						});
					} else {
						// Aqui vem data e totalCount
						setPeopleData(response.data);
						setTotalCount(response.totalCount ?? 0);
					}
				})
				.finally(() => setIsLoading(false));
		});
	};

	useEffect(() => {
		//const paramText = searchParams.get("textSearch") ?? "";
		const rawText = searchParams.get("textSearch") ?? "";
		const paramText = rawText
			.replace(/[.\-]/g, "") // remove pontos e traços
			.replace(/\s+/g, " ") // troca múltiplos espaços por 1
			.trim(); // remove espaços do início/fim

		const paramStatus = searchParams.get("status") ?? "Todos";

		// Atualiza estados locais
		setTextSearch(paramText);
		setStatus(paramStatus);

		// Chama a busca passando page e rowsPerPage
		handleFetchData(page, rowsPerPage, paramText, paramStatus);
	}, [searchParams, page, rowsPerPage, refreshTable]);

	const handleChangePage = (newPage: number) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (newRowsPerPage: number) => {
		setRowsPerPage(newRowsPerPage);
		setPage(0); // Se a primeira página for "1". Se for zero-based, use setPage(0)
	};

	const handleSearch = () => {
		setPage(0);
		const params: any = {};
		// Monta só se não estiver vazio (pra não poluir a URL)
		if (textSearch) params.textSearch = textSearch;
		if (status && status !== "Todos") params.status = status;
		setSearchParams(params);
	};

	return (
		<LayoutBaseDePagina
			titulo="BlackList"
			subtitulo="Controle de BlackList"
			barraDeFerramentas={
				<PeopleToolbar
					showInputSearch
					showStatusSelect
					textSearch={textSearch}
					onChangeTextSearch={setTextSearch}
					onClearTextSearch={() => setTextSearch("")}
					onChangeStatus={setStatus}
					onClickRefresh={handleSearch}
					onClickCreate={handleCreate}
				/>
			}
		>
			<LoadingComp isopen={isLoading} />

			<TablePeople
				rows={peopleData}
				page={page}
				rowsPerPage={rowsPerPage}
				totalCount={totalCount}
				onPageChange={handleChangePage}
				onRowsPerPageChange={handleChangeRowsPerPage}
				onRefresh={handleRefreshTable}
			/>

			{modalCreateOpen && (
				<ModalCreatePeople
					open={modalCreateOpen}
					onClose={() => {
						setModalCreateOpen(false);
						handleRefreshTable();
					}}
					onSuccess={handleRefreshTable}
				/>
			)}
		</LayoutBaseDePagina>
	);
};
